import axios from "axios";
import { getToken } from "../Utils/Common";
import token_valid from "./TokenValid";

const BASE = process.env.REACT_APP_API_URL;

// Save (create when body.id is null, else update). createdBy is derived from the
// JWT principal server-side, so it is not sent here.
const saveReportTemplate = async (body) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .post(BASE + "/api/report-template/save", body, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("saveReportTemplate error", e);
      return null;
    });
};

const getReportTemplateById = async (id) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .get(BASE + "/api/report-template/" + id, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("getReportTemplateById error", e);
      return null;
    });
};

const listReportTemplatesByDomain = async (domain) => {
  const valid = await token_valid();
  if (!valid) return [];
  const token = getToken();
  return axios
    .get(BASE + "/api/report-template/by-domain/" + domain, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("listReportTemplatesByDomain error", e);
      return [];
    });
};

const deleteReportTemplate = async (id) => {
  const valid = await token_valid();
  if (!valid) return false;
  const token = getToken();
  return axios
    .post(
      BASE + "/api/report-template/delete/" + id,
      {},
      { headers: { Authorization: "Bearer " + token } }
    )
    .then(() => true)
    .catch((e) => {
      console.log("deleteReportTemplate error", e);
      return false;
    });
};

export {
  saveReportTemplate,
  getReportTemplateById,
  listReportTemplatesByDomain,
  deleteReportTemplate,
};
